import React from "react";
import styled from "@emotion/styled";

export const InvisibleFileInput = styled.input`
  display: none;
`;
